import { Box, Fade, Stack } from "@mui/material";
import React from "react";

import { Clear, Delete, DeleteSweep, Done } from "@mui/icons-material";
import IconButtonWithLabel from "../../IconButtonWithLabel";
import ScaleChanger from "../../Designer/ScaleChanger";

function getLongestDistance(polygon) {
  if (!polygon) {
    return 0;
  }
  if (polygon.length < 2) {
    return 0;
  }
  let longestDistance = 0;
  for (let i = 0; i < polygon.length; i++) {
    const point = polygon[i];
    const nextPoint = polygon[i + 1] || polygon[0];
    const distance = Math.sqrt(
      Math.pow(point.x - nextPoint.x, 2) + Math.pow(point.y - nextPoint.y, 2)
    );
    if (distance > longestDistance) {
      longestDistance = distance;
    }
  }
  return longestDistance;
}

const ToolbarDesignerCreatingPolygon = ({
  polygon,
  mPerPixel,
  onMPerPixelChange,
  onComplete,
  onCancel,
  onDelete,
  onDeleteAll,
  open,
}) => {
  console.log(polygon);

  const distancePixels = getLongestDistance(polygon);
  const distance = distancePixels * mPerPixel;

  const handleDistanceChanged = (e) => {
    const newDistance = e.target.value;
    console.log(newDistance, distancePixels * mPerPixel);
    const newMPerPixel = newDistance / distancePixels;
    console.log(newMPerPixel);
    onMPerPixelChange(newMPerPixel);
  };

  return (
    <Fade in={open} timeout={500}>
      <Box
        style={{
          display: "flex",
          position: "fixed",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-end",
          pointerEvents: "none",
          padding: "24px",
          bottom: 0,
          left: 0,
          right: 0,
        }}
      >
        {/* <Box
          style={{
            background: "rgb(255,255,255)",
            borderRadius: "1rem",
            padding: ".5rem",
            border: "1px solid #0000001a",
            alignSelf: "center",
            position: "relative",
          }}
        ></Box> */}
        <Box
          style={{
            maxWidth: "100%",
            display: "flex",
            flexDirection: "row",
            pointerEvents: "auto",
            WebkitUserSelect: "none",
            background: "rgb(255,255,255)",
            boxSizing: "border-box",
            boxShadow:
              "0 0 0 1px #0000001a, 0 3px 16px #00000014, 0 2px 6px 1px #00000017",
            borderRadius: "14px",
            position: "relative",
            alignSelf: "center",
          }}
        >
          <ScaleChanger distance={distance} onChange={handleDistanceChanged} />
          <Box
            style={{
              position: "relative",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Stack direction={"row"}>
              {/* Delete */}
              <Box onClick={onComplete}>
                <IconButtonWithLabel label="Complete" icon={<Done />} />
              </Box>
              <Box onClick={onCancel}>
                <IconButtonWithLabel label="Cancel" icon={<Clear />} />
              </Box>

              {/* Delete */}
              <Box onClick={onDelete}>
                <IconButtonWithLabel label="Delete" icon={<Delete />} />
              </Box>
              {/* Delete All */}
              {/* <Box onClick={onDeleteAll}>
                <IconButtonWithLabel
                  label="Delete All"
                  icon={<DeleteSweep />}
                />
              </Box> */}
            </Stack>
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};

export default ToolbarDesignerCreatingPolygon;
